import React from 'react';
import styled from 'styled-components';
import { FilterLabel } from '@lt/components';

import { useTranslation, i18n } from '@lt/localization';
import MultichoiceFilterGroup from './components/MultichoiceFilterGroup';
import { FilterPropTypes, FilterDefaultProps } from './proptypes';
import Icon from '../Icon';

const LABEL_TEXT = i18n.t('filters.extras.title');

const Label = styled.span`
  display: flex;
  align-items: center;
`;
const StyledIcon = styled(Icon)`
  margin-left: 6px;
`;

const StyledFilterLabel = styled(FilterLabel)`
  * {
    white-space: normal;
  }
`;

const getFilterLabel = () => (
  <Label>
    {LABEL_TEXT}
    <StyledIcon type="gift" className="lt-icons__gift--gold" />
  </Label>
);

const FilterLtExtras = (props) => {
  const { t } = useTranslation();
  return (
    <MultichoiceFilterGroup
      {...props}
      Filter={{
        ...FilterLtExtras,
        filterLabel: getFilterLabel(),
      }}
      expandLabel={t('filters.show_offers')}
      visibleItems={5}
      LabelComponent={StyledFilterLabel}
    />
  );
};

FilterLtExtras.filterName = 'lt_extras';
FilterLtExtras.filterLabel = LABEL_TEXT;

FilterLtExtras.propTypes = FilterPropTypes;
FilterLtExtras.defaultProps = FilterDefaultProps;

export default FilterLtExtras;
